<template>
  <div class="card">
    <a-row :gutter="8" class="header">
      <a-col :md="24" :sm="24" class="title">
        {{ title }}
      </a-col>
      <a-col :md="24" :sm="24">
        <a-form layout="inline">
          <a-form-item label="类型">
            <a-select v-model:value="param.type">
              <a-select-option value="sum">累加</a-select-option>
              <a-select-option value="avg">平均</a-select-option>
              <a-select-option value="count">计数</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="周期">
            <a-select v-model:value="param.interval">
              <a-select-option value="year">年</a-select-option>
              <a-select-option value="month">月</a-select-option>
              <a-select-option value="day">日</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="日期">
            <a-range-picker
              :format="picker.fmt"
              v-model:value="param.successTime"
              :mode="picker.mode"
              @panelChange="onPannelChange"
              separator="-"
              :allowClear="true"
              :disabledDate="disabledDateFun"
            />
          </a-form-item>
          <a-form-item>
            <sc-btn :handler="update" text="确定" />
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <div style="height: 200px" class="content">
      <canvas ref="myChart" />
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {request} from '@/util/request';
import Chart from 'chart.js/auto';
import dayjs, {Dayjs} from 'dayjs';

export default defineComponent({
  name: 'Chart',
  props: {
    title: String,
    name: String,
  },
  data() {
    return {
      param: {
        type: 'sum',
        interval: 'day',
        successTime: [
          dayjs().subtract(8, 'day').startOf('day'),
          dayjs().subtract(1, 'day').endOf('day'),
        ],
      },
      chart: null as any,
      o: null as any,
    };
  },
  mounted() {
    this.update();
  },
  computed: {
    picker(): { fmt: string; mode: string[] } {
      const mode: Record<string, string> = {
        day: 'date',
        month: 'month',
        year: 'year',
      };
      const fmtRecord: Record<string, string> = {
        day: 'YYYY/MM/DD',
        month: 'YYYY/MM',
        year: 'YYYY',
      };
      return {
        fmt: fmtRecord[this.param.interval],
        mode: [mode[this.param.interval], mode[this.param.interval]],
      };
    },
  },
  methods: {
    async update() {
      const res = await request('/payment/aggregate/index', {
        name: this.name,
        type: this.param.type,
        interval: this.param.interval,
        startTime: this.param.successTime[0].valueOf().toString(),
        endTime: this.param.successTime[1].valueOf().toString(),
      });
      if (this.chart) {
        this.chart.destroy();
      }
      this.chart = new Chart(this.$refs.myChart as any, {
        type: 'line',
        data: {
          labels: res.labels,
          datasets: [
            {
              label: '',
              borderColor: '#363636',
              borderWidth: 1,
              data: res.values,
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
        },
      });
    },
    disabledDateFun(currentDate: Dayjs) {
      return currentDate.isAfter(dayjs().subtract(1, 'day'));
    },
    onPannelChange(val: Dayjs[], mode: string[]) {
      console.log(
        mode,
        this.picker.mode,
        mode[0] === this.picker.mode[0] || mode[1] === this.picker.mode[0]
      );
      if (mode[0] === this.picker.mode[0] || mode[1] === this.picker.mode[0]) {
        if (this.picker.mode[0] === 'month') {
          this.param.successTime[1] = val[1].startOf('month');
          this.param.successTime[0] = val[0].endOf('month');
        }
        if (this.picker.mode[0] === 'year') {
          this.param.successTime[1] = val[1].startOf('year');
          this.param.successTime[0] = val[0].endOf('year');
        }
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid #f0f0f0;

  .header {
    border-bottom: 1px solid #f0f0f0;
    padding: $spacing-small;
    justify-content: center;

    .title {
      color: $color-content-text-primary;
      font-size: $font-size-medium;
      display: flex;
      align-items: center;
      flex-grow: 1;
    }
  }

  .content {
    padding: $spacing-small;
  }
}
</style>
